import { useMemo } from "react";
import { connect, ConnectedProps } from "react-redux";
import { actions, rainModalSelector } from "reducers/rainModal";
import { RainUpdateParamsType } from "reducers/types/rainModal";
import { AppDispatch, RootState } from "store";
import { updateRainValidationSchema } from "../schemas";
import { RainList } from "./RainList";
import { RainListContainerPropsType } from "./types";

const RainListContainer = (
  props: RainListContainerPropsType & ConnectorProps
): JSX.Element => {
  const validationSchema = useMemo(() => {
    return updateRainValidationSchema(props.timeErrorCode);
  }, [props.timeErrorCode]);
  return <RainList {...props} validationSchema={validationSchema} />;
};

const mapStateToProps = (state: RootState) => ({
  rainDirty: rainModalSelector(state).rainDirty,
  timeErrorCode: rainModalSelector(state).timeErrorUpdate,
  validatingRainTime: rainModalSelector(state).validatingRainTime,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  deleteRain: (rainId: string) => {
    dispatch(actions.deleteRainFetch(rainId));
  },
  updateRain: (params: RainUpdateParamsType) => {
    dispatch(actions.updateRainFetch(params));
  },
  setRainDirty: (dirty: boolean) => {
    dispatch(actions.setRainDirty(dirty));
  },
  resetValidation: () => {
    dispatch(actions.resetTimeErrorUpdate());
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(RainListContainer);
